// extracted by mini-css-extract-plugin
export default {"borderedHr":"AddInventory_borderedHr__F80Te","borderedHr2":"AddInventory_borderedHr2__Wx+Pu","formMain":"AddInventory_formMain__Oyj+0"};